import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.95, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.1, delay: delay + i * 0.14, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const RevealImage = ({ src, alt = "", className = "", imgClassName = "", delay = 0, cursor, onClick }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-5% 0px -5% 0px" });
  return (
    <div ref={ref} className={`editorial-frame ${className}`} data-cursor={cursor} onClick={onClick}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover ${imgClassName}`}
        initial={{ opacity: 0.001, scale: 1.16 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 1.5, delay, ease: EASE }}
      />
      <motion.div
        aria-hidden="true"
        className="absolute inset-0 bg-bone pointer-events-none z-10"
        initial={{ y: "0%" }}
        animate={inView ? { y: "-102%" } : {}}
        transition={{ duration: 1.15, delay: delay + 0.08, ease: EASE }}
      />
    </div>
  );
};
